import React, { useEffect, useState } from "react";
import { Input, Popover, Select } from "antd";
import { isEmpty } from "lodash";
import { handleError } from "../sagas";
import { EXPENSE_STATUS_ID, roles } from "../../../configs/constants";
import axios from "axios";

import { expenseNoSReportsApiUpsellProvider } from "./../../../lib/api/providers";

const Option = Select.Option;

const baseURL = process.env.REACT_APP_API;

const { TextArea } = Input;

export const RefusedRejectedInformations = ({ data }) => {
  return (
    <div className="border-t-2">
      <div className="flex my-2">
        <div className="font-bold mr-2">Motif : </div>
        <div>{data && data.type && data.type.label}</div>
      </div>
      {data && data.comment && (
        <div className="flex">
          <div className="font-bold mr-2">Commentaire : </div>
          <div>{data.comment}</div>
        </div>
      )}
    </div>
  );
};

const ManagerAccountantActionsButtons = ({
  userId,
  requestToTriggered,
  token,
  closeModal,
  rejectTypes,
  userRoleId,
  expense,
  isModalVisible
}) => {
  const status = expense.status || {};

  const [rejectDataToSend, setRejectDataToSend] = useState({});
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);

  const getRecipient = () => {
    // if (expense.processed) return expense.processed_by.user_fullname;
    // else return expense.user_fullname;
    return expense.user_fullname;
  };

  useEffect(() => {
    if (!isEmpty(rejectTypes)) {
      setRejectDataToSend({
        type: {
          id: rejectTypes[0].id,
          label: rejectTypes[0].label
        },
        comment: "",
        recipients: [getRecipient()]
      });
    }
  }, [rejectTypes]);

  const handleOnClickDelete = async () => {
    const endpoint = "/remove";

    try {
      await expenseNoSReportsApiUpsellProvider.post(
        endpoint,
        {
          _id: expense._id
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setIsPopOverOpen(false);
      requestToTriggered();
    } catch (e) {
      setIsPopOverOpen(false);
      handleError(e);
      console.log(e, e.response);
    }
    closeModal();
  };

  const handleOnClickRefuse = async () => {
    const endpoint = status.id === 1 && userRoleId !== roles.DIRECTOR ? "/refuse" : "/reject";
    const key = status.id === 1 ? "refused_infos" : "rejected_infos";
    try {
      await expenseNoSReportsApiUpsellProvider.post(
        endpoint,
        {
          _id: expense._id,
          [key]: { ...rejectDataToSend }
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setIsPopOverOpen(false);
      requestToTriggered();
    } catch (e) {
      setIsPopOverOpen(false);
      handleError(e);
      console.log(e, e.response);
    }
    closeModal();
  };

  async function handleOnClickAccept() {
    const endpoint = status.id === 1 && userRoleId === roles.MANAGER ? "/prevalidate" : "/validate";

    try {
      await expenseNoSReportsApiUpsellProvider.post(endpoint, expense, {
        headers: {
          Authorization: token
        }
      });
      setIsPopOverOpen(false);
      requestToTriggered();
    } catch (e) {
      setIsPopOverOpen(false);
      handleError(e);
    }
    closeModal();
  }

  const popOverContent = (
    <div className="w-96 p-2">
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">Motif :</span>
        <Select
          placeholder=""
          value={rejectDataToSend && rejectDataToSend.type && rejectDataToSend.type.id}
          onChange={typeSelectedId => {
            setRejectDataToSend({
              ...rejectDataToSend,
              type: {
                id: typeSelectedId,
                label: rejectTypes.find(item => item.id === typeSelectedId).label
              }
            });
          }}
        >
          {!isEmpty(rejectTypes) &&
            rejectTypes.map(type => (
              <Option key={type.id} value={type.id}>
                {type.label}
              </Option>
            ))}
        </Select>
      </div>
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">Commentaire :</span>
        <TextArea
          rows={4}
          value={rejectDataToSend && rejectDataToSend.comment}
          onChange={e => setRejectDataToSend({ ...rejectDataToSend, comment: e.target.value })}
        />
      </div>
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">Destinataire :</span>
        <div className="m-2">{rejectDataToSend && rejectDataToSend.recipients && rejectDataToSend.recipients[0]}</div>
      </div>
      <div
        className="mt-12 flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
        onClick={() => handleOnClickRefuse()}
      >
        {expense.processed || userRoleId === roles.DIRECTOR ? "Rejeter" : "Refuser"} la note de frais
      </div>
    </div>
  );

  const areButtonsDisplayed = () => {
    if (expense.transfer && expense.transfer.status && expense.transfer.status.id === 2) return false;
    if (status.id === EXPENSE_STATUS_ID.PENDING && userId === expense.user_id) return false;
    else if (userRoleId === roles.MANAGER && status.id === EXPENSE_STATUS_ID.PENDING) return true;
    else if (userRoleId === roles.DIRECTOR && status.id === EXPENSE_STATUS_ID.PENDING) return true;
    else if (
      (userRoleId === roles.ADMIN || userRoleId === roles.DIRECTOR) &&
      (status.id === EXPENSE_STATUS_ID.PENDING || status.id === EXPENSE_STATUS_ID.PREVALIDATED)
    )
      return true;
    return false;
  };

  const getStatusLabelStyle = () => {
    if (status.id === EXPENSE_STATUS_ID.REFUND) return "text-yellow-300";
    if (status.id === EXPENSE_STATUS_ID.PREVALIDATED) return "text-green-400";
    if (status.id === EXPENSE_STATUS_ID.VALIDATED) return "text-blue-500";
    if (status.id === EXPENSE_STATUS_ID.REFUSED) return "text-purple-400";
    return "text-red-500";
  };

  return (
    <div>
      {areButtonsDisplayed() ? (
        <div>
          <div
            className="flex justify-center cursor-pointer mb-2 px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => handleOnClickAccept()}
          >
            {status.id === 1 && userRoleId !== roles.DIRECTOR ? "Accepter" : "Valider"}
          </div>
          <Popover visible={isPopOverOpen && isModalVisible} placement="right" content={popOverContent}>
            <div
              onClick={() => setIsPopOverOpen(true)}
              className="flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
            >
              {status.id === 1 && userRoleId !== roles.DIRECTOR ? "Refuser" : "Rejeter"}
            </div>
          </Popover>
        </div>
      ) : (
        <div>
          <div>
            <div className="my-2">
              <span className={`my-1 mr-2 font-bold `}>{`Statut :`}</span>
              <div className={`ml-2 inline-flex font-bold ${getStatusLabelStyle()}`}>{`${status.label}`}</div>
            </div>
          </div>
          {status.id === 4 && <RefusedRejectedInformations data={expense.refused_infos} />}
          {status.id === 5 && <RefusedRejectedInformations data={expense.rejected_infos} />}
        </div>
      )}
      {status.id === EXPENSE_STATUS_ID.PENDING && (
        <div
          onClick={() => handleOnClickDelete()}
          className="mt-2 flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-700 text-white"
        >
          Supprimer
        </div>
      )}
    </div>
  );
};

export default ManagerAccountantActionsButtons;



// WEBPACK FOOTER //
// src/modules/presence/components/MangerAccountActionsButtons.modal.js